import React from "react";

export default function FilterBar({
  children,
  className = "",
  align = "between",
  wrap = true,
  ...rest
}) {
  const classes = [
    "rm-filters",
    align ? `rm-filters--${align}` : "",
    wrap ? "is-wrap" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
